import { scale } from '@components/frame';
import { TILE_CONFIG } from '@v2/pages/common/constants/base.constants';

const MONTHS = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'] as const;

export const getImageSize = (itemSize: number, isLineMode: boolean) => {
  if (isLineMode) {
    return { width: scale(TILE_CONFIG.LINE_MODE_WIDTH), height: scale(TILE_CONFIG.LINE_MODE_HEIGHT) };
  }
  const prop = itemSize / TILE_CONFIG.BASE_WIDTH;
  const newHeight = TILE_CONFIG.BASE_HEIGHT * prop;
  return { width: itemSize - 2, height: newHeight };
};

export const getItemDate = (item: { date?: string; plannedStart?: string }): string => {
  const dateStr = item.date || item.plannedStart;
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';
  return `${date.getDate()}-${MONTHS[date.getMonth()]}`;
};

export const getItemStyle = (
  isEmpty: boolean,
  itemSize: number,
  index: number,
  isSmallMode: boolean,
  isWeb: boolean,
) => {
  const style: Record<string, any> = {
    opacity: isEmpty ? 0 : 1,
    marginBottom: (!isWeb && index === 0) ? 0 : scale(isSmallMode ? TILE_CONFIG.MARGIN_BOTTOM_SMALL : TILE_CONFIG.MARGIN_BOTTOM_NORMAL),
  };
  if (itemSize) {
    style.width = itemSize;
  }
  return style;
};

export const buildImageData = (
  item: Record<string, any>,
  imgSize: { width: number; height: number },
  onPress: (e?: any) => void,
  attachMode?: boolean,
) => ({
  image: {
    documentId: item.imageDocumentId,
    imageHash: item.imageHash,
    imageData: {
      isCropped: item.imageData?.isCropped,
      extensionDerivative: item.imageData?.extensionDerivative,
      pageNumber: item.imageData?.pageNumber,
      rotationAngle: item.imageData?.rotationAngle || 0,
      rotationAngleCrop: item.imageData?.rotationAngle || 0,
    },
    width: imgSize.width,
    height: imgSize.height,
    contextId: item.partId,
    contextCode: 'p',
    borderRadius: TILE_CONFIG.BORDER_RADIUS,
  },
  onPress,
  showImageControl: true,
  attachMode,
});
